import WebsiteEntertainmentModel from '@models/website/WebsiteEntertainmentModel';
import doc                       from '@widesk-core/decorators/doc';
import WebsiteServiceModel       from '@/models/WebsiteServiceModel';
import Blamable                  from '@/models/traits/Blamable';
import { Addable }               from '@widesk-core/decorators/addable';
import { Editable }              from '@widesk-core/decorators/editable';
import { Deletable }             from '@widesk-core/decorators/deletable';
import { Timestampable }         from '@widesk-core/decorators/timestampable';

@doc.path('/plannings/{?id}')
@doc.addable
@doc.editable
@doc.deletable
@doc.timestampable
abstract class AbstractPlanningModel extends Blamable(WebsiteServiceModel) {
	declare protected _tsFilters: {
		'partial': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'planningDates.date[before]': id;
		'planningDates.date[strictly_before]': id;
		'planningDates.date[after]': id;
		'planningDates.date[strictly_after]': id;
		'websiteEntertainment': id;
		'websiteEntertainment.slugPrefix': id;
		'private': string;
		'slug': id;
		'planningPlaces.place': id;
		'planningUserGroups.userGroup': id;
		'planningTaxonomies.taxonomy': id;
		'planningTags.tag': id;
		'planningEventTypes.eventType': id;
		'search': string;
	};

	declare private _tsSorts: {
		'id': string;
		'private': string;
		'createdAt': string;
		'updatedAt': string;
		'translations.title': string;
	};

	@doc.boolean declare private: boolean;
	@doc.date declare startHour: Dayjs;
	@doc.date declare endHour: Dayjs;
	@doc.string declare slug: string;
	@doc.model(WebsiteEntertainmentModel)
	declare websiteEntertainment: WebsiteEntertainmentModel;
}

interface AbstractPlanningModel
	extends Addable,
		Editable,
		Deletable,
		Timestampable {}

export default AbstractPlanningModel;
